// store/data/global.js
import { createSlice } from "@reduxjs/toolkit";

export const navItems = [
  { path: "/", key: "/", name: { EN: "Home", JA: "ホーム" } },
  { path: "/about-kigen", key: "aboutKigen", name: { EN: "About Kigen", JA: "崎源について" } },
  { path: "/services", key: "services", name: { EN: "Products & Services", JA: "製品とサービス" } },
  { path: "/technology", key: "technology", name: { EN: "Technology", JA: "テクノロジー" } },
];

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    currentLanguage: 'JA',
    translations: {
      IndexBannerList: {
        JA: {
          headerONE: '崎源株式会社',
          headerTWO: 'グローバル合規算力駆動のBCI-AI科技企業',
          headerTHREE:'算力を基盤に、AIをエンジンに、製品を载体に、グローバルにサービス',
          subheader: [
            '「日本研究開発・欧米推論・東南アジア前処理」の三級グローバル算力アーキテクチャを独自構築。',
            '6大独自AIエンジン全スタックカバー。C端定期課金とB端BPO双軸並行。安全・合規・持続可能な脳機AI商業エコシステムを構築',
          ],
        },
        EN: {
          headerONE: 'Kigen Co., Ltd.',
          headerTWO: 'A Global Compliant Computing-Driven BCI-AI Technology Enterprise',
          headerTHREE:'Based on computing power, powered by AI, and carried out through products, serving the entire world',
          subheader: [
            'Pioneering a three-tier global computing architecture: "Japan R&D — Europe/Americas Inference — Southeast Asia Pre-processing";',
            ' 6 proprietary AI engines with full-stack coverage; C-end subscription and B-end outsourcing in parallel; building a safe, compliant, sustainable BCI-AI business ecosystem.',
          ],
        }
      },
      IndexHistoryList: {
        JA: {
          caption: '会社の沿革',
          content: [
            '崎源株式会社は東京に本社を置き、脳機AIアルゴリズム研究開発・合規算力配置・生物智能コンテンツサービスに特化した国際科技企業です。',
            '「日本研究開発・欧米推論・東南アジア前処理」の三級グローバル算力アーキテクチャを独自構築し、国際輸出規制とデータ合規基準に厳格に従います。',
            '非医療・合規の消費級脳機AI商業体系として、スケール可能で収益性のある低リスクBCI算力サービスを提供します。',
            '算力を基盤、AIをエンジン、製品を载体とし、データ取得からコンテンツ出力までの商業クローズループを構築しています。',
          ],
        },
        EN: {
          caption: 'HISTORY',
          content: [
            'Headquartered in Tokyo, Kigen Co., Ltd. specializes in BCI-AI algorithm R&D, compliant computing deployment, and bio-intelligent content services.',
            'We pioneered a three-tier architecture — Japan R&D, Europe/Americas Inference, Southeast Asia Pre-processing — with strict export and data compliance.',
            'A non-medical, compliant consumer-grade BCI-AI framework, and a scarce scalable, profitable, low-risk computing provider.',
            'With computing as foundation, AI as engine, and products as carrier, we close the loop from data acquisition to content output.',
          ]
        }
      },
      IndexCultureList: {
        JA: [
          {
            header: '企業理念',
            description: [
              '「合規算力で脳機AIの未来を拓く」',
              'テクノロジーは効率の手段ではなく、安全で持続可能な脳機AI商業生態を築く基盤だと信じています。',
              '日本研究開発・欧米推論・ASEAN前処理の三級体制を軸に、C端プロダクトとB端サービスを両立し、データからコンテンツまでのクローズループを実現します。',
            ],
          },
          {
            header: '企業文化',
            description: [
              '合規ファースト：国際輸出規制とデータプライバシーを最優先に据えます。',
              'ゼロベース思考：固定観念を超え、自研AIエンジンとプロダクトで挑戦し続けます。',
              'グローバル協働：国境を越えたチームで、包摂的かつ高速な実行文化を育てます。',
            ],
          },
        ],
        EN: [
          {
            header: 'Corporate Philosophy',
            description: [
              '"Unlocking the Future of BCI-AI with Compliant Computing"',
              'Technology is not just a tool for efficiency — it is the foundation of a safe, sustainable BCI-AI business ecosystem.',
              'Anchored in Japan R&D, Europe/Americas inference, and ASEAN pre-processing, we run C-end products and B-end services in parallel, closing the loop from data to content.',
            ]
          },
          {
            header: 'Corporate Culture',
            description: [
              'Compliance first: international export controls and data privacy come before everything else.',
              'Zero-based thinking: we challenge assumptions and keep building proprietary AI engines and products.',
              'Global collaboration: cross-border teams fostering an inclusive, high-velocity execution culture.',
            ]
          }
        ]
      },
      IndexTeamList: {
        JA: {
          description: [
            '当社のチームは、脳機AIアルゴリズム、合規算力アーキテクチャ、消費級プロダクト開発に精通した専門家で構成されています。',
            '日本研究開発から欧米推論・ASEAN前処理まで、三級グローバル体制を横断し、安全で持続可能な脳機AIエコシステムを推進します。',
            'C端プロダクトとB端サービスを両立させ、データからコンテンツ出力までのクローズループを共に実現します。',
          ],
          list: [
            {
              header: '脳機AIアルゴリズム研究開発チーム',
              lineCover: require('@/assets/home/Team1.webp'),
            },
            {
              header: 'グローバル合規算力アーキテクチャチーム',
              lineCover: require('@/assets/home/Team2.webp'),
            },
            {
              header: 'C端消費級プロダクトチーム',
              lineCover: require('@/assets/home/Team3.webp'),
            },
            {
              header: 'B端企業ソリューション・BPOチーム',
              lineCover: require('@/assets/home/Team4.webp'),
            },
            {
              header: 'データ合規・セキュリティガバナンスチーム',
              lineCover: require('@/assets/home/Team5.webp'),
            },
            {
              header: 'グローバルオペレーション・カスタマーサクセスチーム',
              lineCover: require('@/assets/home/Team6.webp'),
            },
          ],
        },
        EN: {
          description: [
            'Our team brings together specialists in BCI-AI algorithms, compliant computing architecture, and consumer-grade product development.',
            'Across Japan R&D, Europe/Americas inference, and ASEAN pre-processing, we advance a safe, sustainable BCI-AI ecosystem.',
            'We run C-end products and B-end services in parallel, closing the loop from data acquisition to content output.',
          ],
          list: [
            {
              header: 'BCI-AI Algorithm R&D Team',
              lineCover: require('@/assets/home/Team1.webp'),
            },
            {
              header: 'Global Compliant Computing Architecture Team',
              lineCover: require('@/assets/home/Team2.webp'),
            },
            {
              header: 'C-End Consumer Product Team',
              lineCover: require('@/assets/home/Team3.webp'),
            },
            {
              header: 'B-End Enterprise Solutions & BPO Team',
              lineCover: require('@/assets/home/Team4.webp'),
            },
            {
              header: 'Data Compliance & Security Governance Team',
              lineCover: require('@/assets/home/Team5.webp'),
            },
            {
              header: 'Global Operations & Customer Success Team',
              lineCover: require('@/assets/home/Team6.webp'),
            },
          ],
        },
      },
      IndexDutyList: {
        JA: [
          {
            header: '当社の責任',
            description: [
              'グローバルで稀少なスケール可能・収益性・低リスクBCI算力サービス提供者として、「日本に拠点を置き、グローバルにサービスを提供」——合規算力・独自アルゴリズム・智能コンテンツエコシステムを核心に据えます。',
              '安全・持続可能・グローバル化された消費級脳機AIインフラを継続構築し、非医療・合規の枠組みで社会に届けます。',
              '次世代神経智能デジタルサービスのリーディング企業を目指し、データ取得からコンテンツ出力までの商業クローズループに責任を果たします。',
            ],
          },
        ],
        EN: [
          {
            header: 'Our Responsibilities',
            description:[
              'As a globally scarce, scalable, profitable, low-risk BCI computing service provider, we are "Based in Japan, Serving the World" — centered on compliant computing, proprietary algorithms, and an intelligent content ecosystem.',
              'We continuously build safe, sustainable, globalized consumer-grade BCI-AI infrastructure, delivering within a non-medical, compliant framework.',
              'Aiming to lead next-generation neural intelligent digital services, we uphold a complete commercial closed loop from data acquisition to content output.',
            ]
          }
        ]
      },
      IndexMilestonesList: {
        EN: {
          title: 'Key Metrics at a Glance',
          list: [
            { value: 24, unit: 'h', label: 'Global three-tier computing 24/7 continuous operation' },
            { value: 5, unit: '+', label: '5+ regions compliant deployment' },
            { value: 3, unit: '-Tier', label: 'Japan→Europe/Americas→ASEAN three-tier architecture' },
            { value: 6, unit: 'Engines', label: 'Full-stack proprietary; zero third-party dependency' },
            { value: 6, unit: 'Products', label: '6 commercialized products' },
            { value: 3, unit: 'Tracks', label: 'C-end + B-end + R&D three high-growth tracks' },
            { value: 0, unit: 'Medical', label: 'Completely outside medical regulation' },
          ],
        },
        JA: {
          title: '核心データ速覧',
          list: [
            { value: 24, unit: 'h', label: 'グローバル三級算力全天候永続稼働' },
            { value: 5, unit: '+', label: '5+地域合規配置' },
            { value: 3, unit: '級', label: '日本→欧米→ASEAN三級アーキテクチャ' },
            { value: 6, unit: 'エンジン', label: '全スタック独自開発 第三者依存なし' },
            { value: 6, unit: '製品', label: '6大商業化製品' },
            { value: 3, unit: 'トラック', label: 'C端+B端+R&D三大高成長トラック' },
            { value: 0, unit: '医療', label: '医療規制範疇を完全回避' },
          ],
        },
      },
      AboutKigenList: {// Corporate Vision
        JA: [
          {
             header: '日本に拠点を置き、グローバルにサービスを提供',
             content:'「日本に拠点を置き、グローバルにサービスを提供」——合規算力・独自アルゴリズム・智能コンテンツエコシステムを核心に。',
             lineCover:require('@/assets/AboutKigen/Industries-We-Serve1_compressed.webp'),
          },
          {
             header: '消費級脳機AIインフラ',
             content:'安全・持続可能・グローバル化された消費級脳機AIインフラを継続構築します。',
             lineCover:require('@/assets/AboutKigen/Industries-We-Serve2_compressed.webp'),
          },
          {
             header: '神経智能デジタルサービス',
             content:'次世代神経智能デジタルサービスのリーディング企業を目指します。',
             lineCover:require('@/assets/AboutKigen/Industries-We-Serve3_compressed.webp'),
          },
        ],
        EN: [
          {
             header: 'Based in Japan, Serving the World',
             content:'"Based in Japan, Serving the World" — centered on compliant computing, proprietary algorithms, and intelligent content ecosystem.',
             lineCover:require('@/assets/AboutKigen/Industries-We-Serve1_compressed.webp'),
          },
          {
            header: 'Consumer-Grade BCI-AI Infrastructure',
            content:'Continuously building safe, sustainable, globalized consumer-grade BCI-AI infrastructure.',
            lineCover:require('@/assets/AboutKigen/Industries-We-Serve2_compressed.webp'),
         },
         {
          header: 'Neural Intelligent Digital Services',
          content:'Committed to becoming a global leader in next-generation neural intelligent digital services.',
          lineCover:require('@/assets/AboutKigen/Industries-We-Serve3_compressed.webp'),
         },
        ]
      },
      CaseStudiesList: {// Products & Services
        JA: [
          {
            header: 'C端消費級製品',
            clientName: '毎晩の夢をアニメにレンダリング',
            clientPain: 'DreamCanvas・EmotionScope・ConsciousSnap・MindVault——脳波データを没入型パーソナル体験へ変換するC端消費級製品スイート。',
            solution: 'NeuralDiffusion・EmotionSpectrum・NeuralRender・MemoryGraphエンジンにより、睡眠・情緒・ピーク認知・生涯記憶をカバーするエンドツーエンドの神経製品を提供します。',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-1.webp'),
            Results: [
              {
                caption: 'DreamCanvas 夢可視化',
                description: [
                  { title: 'ポジショニング', content: '毎晩の夢をアニメにレンダリング' },
                  { title: '核心機能', content: '睡眠時無侵襲脳波ヘッドバンド着用 → REM脳波取得 → NeuralDiffusion夢アニメレンダリング → App内夢ギャラリー閲覧' },
                  { title: '定着率データ', content: '月間アクティブユーザーの定着率は82％' },
                  { title: '技術エンジン', content: 'NeuralDiffusion' },
                ],
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'EmotionScope 情緒AI解析',
                description: [
                  { title: 'ポジショニング', content: '毎日の情緒スペクトルを読み解く' },
                  { title: '核心機能', content: 'リアルタイム脳波频帯分解 → 6次元情緒スペクトルマッピング → パーソナライズ情緒日報+長期トレンド分析' },
                  { title: '製品形態', content: 'モバイルApp + デスクトップDashboard + API' },
                  { title: '技術エンジン', content: 'EmotionSpectrum' },
                ],
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: 'ConsciousSnap 意識スナップ',
                description: [
                  { title: 'ポジショニング', content: 'ピーク意識瞬間を捕捉、3D景観にレンダリング' },
                  { title: '核心機能', content: '高認知時全频帯脳波捕捉 → NeuralRender 3Dレンダリング → 没入型神経景観体験' },
                  { title: '技術エンジン', content: 'NeuralRender' },
                ],
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
              {
                caption: 'MindVault 記憶構造化',
                description: [
                  { title: 'ポジショニング', content: '唯一無二のデジタルライフログを構築' },
                  { title: '核心機能', content: '長期脳波+情緒ログ融合 → 記憶タイムライン可視化 → AI摘要生成' },
                  { title: '技術エンジン', content: 'MemoryGraph' },
                ],
                Img: require('@/assets/CaseStudies/Studies4.webp'),
              },
            ],
          },
          {
            header: 'B端企業級サービス',
            clientName: 'グローバルBCI企業の合規算力BPOパートナー',
            clientPain: '世界のBCI企業向けに、合規な算力アウトソーシングと即利用可能な脱敏脳波データセットを提供します。',
            solution: 'EEG-PipelineとNeuralGANエンジンにより、エラスティックな算力BPOと、睡眠・情緒・注意力・瞑想シーン向け合成データセット生成を実現します。',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-2.webp'),
            Results: [
              {
                caption: 'BCI-Cloud 算力BPO',
                description: [
                  { title: 'ポジショニング', content: 'グローバルBCI企業の合規算力BPOパートナー' },
                  { title: '核心モジュール', content: 'EEGノイズ除去前処理 / 特徴抽出パイプライン / 神経データモデリング+注釈 / API標準開放' },
                  { title: '拡張', content: '上限なしエラスティック拡張' },
                  { title: '技術エンジン', content: 'EEG-Pipeline' },
                ],
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'NeuroDataForge データセット生成',
                description: [
                  { title: 'ポジショニング', content: '即利用可能な合規脱敏脳波データセット' },
                  { title: '核心機能', content: 'NeuralGAN合成データ拡張 → 合規脱敏データセット批量生成 → 睡眠/情緒/注意力/瞑想4シーン対応' },
                  { title: '優位性', content: 'アルゴリズム研究開発サイクル大幅短縮' },
                  { title: '技術エンジン', content: 'NeuralGAN' },
                ],
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: 'EEG-Pipeline',
                description: 'EEG降噪から特徴抽出、神経データモデリングまでを一気通貫で支える企業向け処理パイプライン。',
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
              {
                caption: 'NeuralGAN',
                description: '合規脱敏データセットを批量生成し、アルゴリズム研究開発サイクルを大幅に短縮します。',
                Img: require('@/assets/CaseStudies/Studies4.webp'),
              },
            ],
          },
          {
            header: 'R&D研究開発パイプライン',
            clientName: '次世代神経智能技術展開',
            clientPain: '個人生物記憶構造化整理 → デジタルライフログ技術 → MindVault孵化。デジタル意識スナップ → 高認知状態捕捉と3D再構築 → ConsciousSnap孵化。',
            solution: 'R&DパイプラインはC端とB端に継続的に新製品と新技術エンジンを供給、製品マトリックスのイテレーション向上を駆動します。',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-3.webp'),
            Results: [
              {
                caption: 'MindVault孵化',
                description: '個人生物記憶構造化整理 → デジタルライフログ技術 → MindVault孵化',
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'ConsciousSnap孵化',
                description: 'デジタル意識スナップ → 高認知状態捕捉と3D再構築 → ConsciousSnap孵化',
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: '三大R&D方向',
                description: '脱敏神経没入型コンテンツ生成 → VR/AR神経感知アート → 次世代C端製品孵化',
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
            ],
          },
        ],
        EN: [
          {
            header: 'C-End Consumer Products',
            clientName: 'We render your nightly dreams into animation',
            clientPain: 'DreamCanvas, EmotionScope, ConsciousSnap, and MindVault — a C-end consumer suite that turns brainwave data into immersive personal experiences.',
            solution: 'Powered by NeuralDiffusion, EmotionSpectrum, NeuralRender, and MemoryGraph engines, we deliver end-to-end neural consumer products spanning sleep, emotion, peak cognition, and lifelong memory.',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-1.webp'),
            Results: [
              {
                caption: 'DreamCanvas Dream Visualization',
                description: [
                  { title: 'Positioning', content: 'We render your nightly dreams into animation' },
                  { title: 'Core Features', content: 'Wear non-invasive EEG headband during sleep → REM brainwave acquisition → NeuralDiffusion renders dream animation → Browse dream gallery in-app' },
                  { title: 'Retention Data', content: 'Monthly active user retention rate: 82%' },
                  { title: 'Engine', content: 'NeuralDiffusion' },
                ],
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'EmotionScope Emotion AI Analysis',
                description: [
                  { title: 'Positioning', content: 'Decoding your daily emotion spectrum' },
                  { title: 'Core Features', content: 'Real-time EEG band decomposition → 6-dimensional emotion spectrum mapping → Personalized emotion daily report + long-term trend analysis' },
                  { title: 'Product Form', content: 'Mobile App + Desktop Dashboard + API' },
                  { title: 'Engine', content: 'EmotionSpectrum' },
                ],
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: 'ConsciousSnap Consciousness Snapshot',
                description: [
                  { title: 'Positioning', content: 'Capture your peak consciousness moments, rendered as 3D landscapes.' },
                  { title: 'Core Features', content: 'Full-band brainwave capture at peak cognitive moments → NeuralRender 3D rendering → Immersive neural landscape experience' },
                  { title: 'Engine', content: 'NeuralRender' },
                ],
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
              {
                caption: 'MindVault Memory Structuring',
                description: [
                  { title: 'Positioning', content: 'Building your unique digital life log' },
                  { title: 'Core Features', content: 'Long-term brainwave + emotion log fusion → Memory timeline visualization → AI summary generation' },
                  { title: 'Engine', content: 'MemoryGraph' },
                ],
                Img: require('@/assets/CaseStudies/Studies4.webp'),
              },
            ],
          },
          {
            header: 'B-End Enterprise Services',
            clientName: 'The compliant computing outsourcing partner for global BCI enterprises',
            clientPain: 'Compliant computing outsourcing and ready-to-use anonymized EEG datasets for global BCI enterprises.',
            solution: 'EEG-Pipeline and NeuralGAN engines power elastic computing BPO and synthetic dataset generation across sleep, emotion, attention, and meditation scenarios.',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-2.webp'),
            Results: [
              {
                caption: 'BCI-Cloud Computing BPO',
                description: [
                  { title: 'Positioning', content: 'The compliant computing outsourcing partner for global BCI enterprises.' },
                  { title: 'Core Modules', content: 'EEG denoising pre-processing / Feature extraction pipeline / Neural data modeling + annotation / Standardized API access' },
                  { title: 'Scaling', content: 'Unlimited elastic scaling; on-demand expansion' },
                  { title: 'Engine', content: 'EEG-Pipeline' },
                ],
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'NeuroDataForge Dataset Generation',
                description: [
                  { title: 'Positioning', content: 'Ready-to-use compliant anonymized EEG datasets' },
                  { title: 'Core Features', content: 'NeuralGAN synthetic data augmentation → Batch generation of compliant anonymized datasets → Covers sleep/emotion/attention/meditation scenarios' },
                  { title: 'Advantage', content: 'Significantly shortens algorithm R&D cycle' },
                  { title: 'Engine', content: 'NeuralGAN' },
                ],
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: 'EEG-Pipeline',
                description: 'An end-to-end enterprise pipeline from EEG denoising and feature extraction to neural data modeling.',
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
              {
                caption: 'NeuralGAN',
                description: 'Batch-generates compliant anonymized datasets and significantly shortens algorithm R&D cycles.',
                Img: require('@/assets/CaseStudies/Studies4.webp'),
              },
            ],
          },
          {
            header: 'R&D Pipeline',
            clientName: 'Next-Generation Neural Intelligence Technology Roadmap',
            clientPain: 'Personal bio-memory structured organization → Digital life log technology → Incubates MindVault. Digital consciousness snapshot → Peak cognitive state capture and 3D reconstruction → Incubates ConsciousSnap.',
            solution: 'R&D pipeline continuously feeds new products and technology engines to C-end and B-end, driving product matrix iteration.',
            solutionImg: require('@/assets/CaseStudies/Cover.gif'),
            CoverImg: require('@/assets/CaseStudies/solution-3.webp'),
            Results: [
              {
                caption: 'Incubates MindVault',
                description: 'Personal bio-memory structured organization → Digital life log technology → Incubates MindVault',
                Img: require('@/assets/CaseStudies/Studies1.webp'),
              },
              {
                caption: 'Incubates ConsciousSnap',
                description: 'Digital consciousness snapshot → Peak cognitive state capture and 3D reconstruction → Incubates ConsciousSnap',
                Img: require('@/assets/CaseStudies/Studies2.webp'),
              },
              {
                caption: 'Three R&D Directions',
                description: 'Anonymized neural immersive content generation → VR/AR neural perception art → Incubates next-gen C-end products',
                Img: require('@/assets/CaseStudies/Studies3.webp'),
              },
            ],
          },
        ],
      },
      WHYChooseUsCustomized:{
        EN:[
          { 
             header: 'Global Compliant Computing Barrier', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us1_compressed.webp'), 
             content:[
               'Japan training',
               'Europe/Americas inference',
               'ASEAN pre-processing',
               '100% NVIDIA/AMD/BIS compliant',
             ],
          },
          { 
            header: 'Low-Risk Commercialization Model', 
            Img:require('@/assets/AboutKigen/Why-Choose-Us2_compressed.webp'), 
            content:[
              'Non-medical positioning',
              'No sensitive data links',
              'No geopolitical risk',
              '24h computing at full capacity',
            ],
         },
         { 
          header: 'High-Margin Compound Growth', 
          Img:require('@/assets/AboutKigen/Why-Choose-Us3_compressed.webp'), 
          content:[
            'Computing subscription as core revenue',
            'Users generate data daily',
            'System operates 24/7',
            'Scale and revenue grow in compound',
          ],
         }, 
         { 
          header: 'Full-Stack Proprietary AI', 
          Img:require('@/assets/AboutKigen/Why-Choose-Us4_compressed.webp'), 
          content:[
            'All 6 engines proprietary',
            'Zero third-party dependency',
            'Technology iteration is self-controlled',
          ],
         },
         { 
          header: 'Deep Business-Product Integration', 
          Img:require('@/assets/AboutKigen/Why-Choose-Us5_compressed.webp'), 
          content:[
            'Three business lines deeply coupled with 6 products',
            'Forming a closed-loop commercial ecosystem',
          ],
         },
         { 
          header: 'Global Compliant Operations', 
          Img:require('@/assets/AboutKigen/Why-Choose-Us6_compressed.webp'), 
          content:[
            'Multi-region distributed deployment',
            'Mitigates single-region policy risk',
            'One of few globally profitable BCI-AI projects',
          ],
         },
        ],
        JA:[
          { 
             header: 'グローバル合規算力バリア', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us1_compressed.webp'), 
             content:[
               '日本訓練',
               '欧米推論',
               'ASEAN前処理',
               'NVIDIA/AMD/BIS規制100%適合',
             ],
          },
          { 
             header: '低リスク商業化モデル', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us2_compressed.webp'), 
             content:[
               '非医療定位',
               'センシティブデータリンクなし',
               '地政学リスクなし',
               '24h算力フル稼働',
             ],
          },
          { 
             header: '高利回り複利成長', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us3_compressed.webp'), 
             content:[
               '算力定期課金を核心収益',
               'ユーザー毎日データ生成',
               'システム全天候演算',
               'スケールと収益同期的複利成長',
             ],
          },
          { 
             header: 'AI全スタック独自開発', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us4_compressed.webp'), 
             content:[
               '6大エンジン全て独自開発',
               '第三者依存なし',
               '技術イテレーション自主制御可能',
             ],
          },
          { 
             header: '事業製品深度結合', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us5_compressed.webp'), 
             content:[
               'C端定期課金+B端BPO+R&D三大事業線と6大製品が深度結合',
               'クローズループ商業エコシステムを形成',
             ],
          },
          { 
             header: 'グローバル化合規運営', 
             Img:require('@/assets/AboutKigen/Why-Choose-Us6_compressed.webp'), 
             content:[
               '多区域分散配置',
               '単一区域政策リスク回避',
               'グローバル極少数の安定収益BCI-AI実装プロジェクト',
             ],
          },         
        ],
      },
      TechnologyCooperation:{
        EN:[
          { 
             title: 'Who We Are', 
             Img:require('@/assets/AboutKigen/Cooperation1.webp'), 
             content:[
              'Headquartered in Tokyo, Japan, Kigen Co., Ltd. is an international technology enterprise specializing in BCI-AI algorithm R&D, global compliant computing deployment, and bio-intelligent content services.',
             ],
          },
          { 
             title: 'Three-Tier Architecture', 
             Img:require('@/assets/AboutKigen/Cooperation2.webp'), 
             content:[
              'The company has pioneered a three-tier global computing architecture: "Japan R&D — Europe/Americas Inference — Southeast Asia Pre-processing," strictly adhering to international export controls and data compliance standards.',
            ],
          },
          { 
            title: 'Business Framework', 
            Img:require('@/assets/AboutKigen/Cooperation3.webp'), 
            content:[
             'A non-medical, entertainment-oriented, compliant consumer-grade BCI-AI business framework; a globally scarce, scalable, profitable, and low-risk BCI computing service provider.',
            ],
         },
          { 
            title: 'Commercial Closed Loop', 
            Img:require('@/assets/AboutKigen/Cooperation4.webp'), 
            content:[
             'With computing as foundation, AI as engine, and products as carriers, building a complete commercial closed loop from data acquisition to content output.',
            ],
         },
        ],
        JA:[
          { 
             title: '私たちについて', 
             Img:require('@/assets/AboutKigen/Cooperation1.webp'), 
             content:[
              '崎源株式会社は東京に本社を置き、脳機AIアルゴリズム研究開発、グローバル合規算力配置、生物智能コンテンツサービスに特化した国際科技企業です。',
             ],
          },
          { 
             title: '三級アーキテクチャ', 
             Img:require('@/assets/AboutKigen/Cooperation2.webp'), 
             content:[
              '「日本研究開発・欧米推論・東南アジア前処理」の三級グローバル算力アーキテクチャを独自構築。国際輸出規制及びデータ合規基準に厳格に従います。',
            ],
          },
          { 
             title: '事業フレームワーク', 
             Img:require('@/assets/AboutKigen/Cooperation3.webp'), 
             content:[
             '非医療エンターテインメント化・合規の消費級脳機AI商業体系。グローバルで稀少なスケール可能・収益性・低リスクBCI算力サービス提供者です。',
            ],
          },
          { 
             title: '商業クローズループ', 
             Img:require('@/assets/AboutKigen/Cooperation4.webp'), 
             content:[
             '算力を基盤・AIをエンジン・製品を载体とし、データ取得からコンテンツ出力までの完全商業クローズループを構築します。',
            ],
          },                    
        ],
      },
      TechnologyPageContent: {
        EN: {
          architectureTitle: 'Three-Tier Computing Architecture',
          compliance:
            'Fully compliant with NVIDIA, AMD, and international BIS export control regulations',
          tiers: [
            {
              tier: 'Tier 1',
              region: 'Japan',
              focus: 'High-end training computing, legally deployed',
              detail: [
                'NVIDIA/AMD high-end GPU legal access',
                'domestic regulatory compliance',
              ],
            },
            {
              tier: 'Tier 2',
              region: 'Europe/Canada',
              focus: 'High-end inference computing, offshore deployed',
              detail: [
                'EU GDPR + BIS compliance',
                'data privacy protection',
              ],
            },
            {
              tier: 'Tier 3',
              region: 'Southeast Asia (ASEAN)',
              focus: 'Large-scale pre-processing computing, elastic scaling',
              detail: [
                'Cost optimization',
                'unlimited elastic scaling',
              ],
            },
          ],
          enginesTitle: 'AI Technology Engines',
          productLabel: 'Applied Product',
          engines: [
            {
              name: 'NeuralDiffusion',
              subtitle: 'Neural Diffusion Model',
              description:
                'EEG spectrum → artistic visual content real-time rendering',
              product: 'DreamCanvas',
            },
            {
              name: 'NeuralGAN',
              subtitle: 'Neural Generative Adversarial Network',
              description:
                'Compliant anonymized EEG dataset batch generation',
              product: 'NeuroDataForge',
            },
            {
              name: 'EmotionSpectrum',
              subtitle: 'Emotion Spectrum',
              description:
                '6-dimensional emotion spectrum real-time mapping & analysis.',
              product: 'EmotionScope',
            },
            {
              name: 'NeuralRender',
              subtitle: 'Neural Rendering',
              description:
                'Brainwave snapshot → immersive 3D neural landscape rendering.',
              product: 'ConsciousSnap',
            },
            {
              name: 'EEG-Pipeline',
              subtitle: 'EEG Processing Pipeline',
              description:
                'Denoising + feature extraction + micro-state analysis integrated',
              product: 'BCI-Cloud',
            },
            {
              name: 'MemoryGraph',
              subtitle: 'Memory Graph',
              description:
                'Long-term brainwave + emotion log structured graph',
              product: 'MindVault',
            },
          ],
        },
        JA: {
          architectureTitle: '三級算力アーキテクチャ',
          compliance:
            'NVIDIA・AMD及び国際BIS輸出規制ルールに完全適合',
          tiers: [
            {
              tier: '第一層',
              region: '日本',
              focus: '高端訓練算力の合法配置',
              detail: [
                'NVIDIA/AMD高端GPU合法接続',
                '日本国内法規合規',
              ],
            },
            {
              tier: '第二層',
              region: '欧州/カナダ',
              focus: '高端推論算力のオフショア配置',
              detail: [
                'EU GDPR + BIS規制適合',
                'データプライバシー保護',
              ],
            },
            {
              tier: '第三層',
              region: 'ASEAN',
              focus: '大規模前処理算力のエラスティック拡張',
              detail: [
                'コスト最適化',
                '上限なしエラスティック拡張',
              ],
            },
          ],
          enginesTitle: 'AI技術エンジン',
          productLabel: '対応製品',
          engines: [
            {
              name: 'NeuralDiffusion',
              subtitle: '神経拡散モデル',
              description:
                'EEG频谱→芸術化視覚コンテンツリアルタイムレンダリング',
              product: 'DreamCanvas',
            },
            {
              name: 'NeuralGAN',
              subtitle: '神経生成対抗ネットワーク',
              description:
                '合規脱敏脳波データセット批量生成',
              product: 'NeuroDataForge',
            },
            {
              name: 'EmotionSpectrum',
              subtitle: '情緒スペクトル',
              description:
                '6次元情緒スペクトルリアルタイムマッピングと分析。',
              product: 'EmotionScope',
            },
            {
              name: 'NeuralRender',
              subtitle: '神経レンダリング',
              description:
                '脳波スナップ→没入型3D神経景観レンダリング',
              product: 'ConsciousSnap',
            },
            {
              name: 'EEG-Pipeline',
              subtitle: '脳波処理パイプライン',
              description:
                'ノイズ除去+特徴抽出+ミクロ状態分析一元化',
              product: 'BCI-Cloud',
            },
            {
              name: 'MemoryGraph',
              subtitle: '記憶グラフ',
              description:
                '長期脳波+情緒ログ構造化グラフ',
              product: 'MindVault',
            },
          ],
        },
      },
    }
  },
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    }
  }
});

// 导出actions
export const { setLanguage } = globalSlice.actions;

// 导出选择器函数
export const getCurrentLanguage = (state) => state.global.currentLanguage;
export const getTranslations = (state) => state.global.translations;

export default globalSlice.reducer;